import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../Common/CustomButton";

export default function ActionConfirmationModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  buttonText = "Confirm",
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  description: string;
  buttonText?: string;
}) {
  const [isConfirming, setIsConfirming] = useState(false);
  return (
    <Dialog open={open} sx={{ borderRadius: "4px" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 2 }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent>
        <Alert severity="info">{description}</Alert>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: 2 }}>
        <CustomButton variant="text" onClick={onClose}>
          Cancel
        </CustomButton>
        <CustomButton
          disabled={isConfirming}
          variant="contained"
          onClick={async () => {
            setIsConfirming(true);
            try {
              await onConfirm();
              onClose();
            } catch (error) {
              console.error("Error moving invoices:", error);
            } finally {
              setIsConfirming(false);
            }
          }}
          startIcon={isConfirming ? <CircularProgress size={24} /> : null}
        >
          {buttonText}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
